(ns bp-clients.tv-app.utils.os
  "Namespace dedicated to OS specifics (eg.: tizen, webos)."
  (:require [re-frame.core :as rf]))

(goog-define device "webos")
(goog-define staging-tizen "https://staging-tizen.brasilparalelo.com.br")
(goog-define staging-webos "https://staging-lg.brasilparalelo.com.br")
(goog-define production-tizen "https://tizen.brasilparalelo.com.br")
(goog-define production-webos "https://lg.brasilparalelo.com.br")

(def user-agent
  "Holds the parsed user-agent. Check UAParser for more info.
   https://www.npmjs.com/package/ua-parser-js"
  (-> (new js/UAParser js/navigator.userAgent)
      .getResult
      (js->clj :keywordize-keys true)))

(def ^:private redirect-config
  "Configs for redirecting between staging and production environment."
  {:webos {:staging-url    staging-webos
           :production-url production-webos}
   :tizen {:staging-url    staging-tizen
           :production-url production-tizen}})

(defn tizen?
  "Returns true if the current build targets tizen devices"
  []
  (= :tizen (keyword device)))

(defn webos?
  "Returns true if the current build targets webos devices"
  []
  (= :webos (keyword device)))

(defn staging-target
  "Returns the staging url for the current device group."
  []
  (->> device
       keyword
       (get redirect-config)
       :staging-url))

(defn production-target
  "Returns the production url for the current device group."
  []
  (->> device
       keyword
       (get redirect-config)
       :production-url))

(defn qa-staging-redirect
  [user-profile]
  (let [staging? (= (-> js/window .-location .-origin) (staging-target))
        qa-user? (= (:email user-profile) "princesa@brasilparalelo.com.br")]
    (cond
      (and staging? (not qa-user?))
      (do (rf/dispatch-sync [:bp-clients.tv-app.auth.events/logout])
          (rf/dispatch-sync [:bp-clients.tv-app.nav.events/set-active-page :login])
          (set! (.-location js/window) (production-target)))

      (and (not staging?) qa-user?)
      (do (rf/dispatch-sync [:bp-clients.tv-app.auth.events/logout])
          (rf/dispatch-sync [:bp-clients.tv-app.nav.events/set-active-page :login])
          (set! (.-location js/window) (staging-target)))

      :else
      nil)))
